import type { IconType } from 'react-icons'
import type { ProjectDetailTab } from '@/frontend/components/ProjectDetailView'
import type { NotificationKind } from '@/frontend/lib/notification-kinds'

export const validTabs = ['overview', 'projects', 'tasks', 'tickets', 'ideas', 'team', 'events'] as const
export type TabKey = (typeof validTabs)[number]

export type PmSearch = {
  // undefined = landing on bare /pm → PmPage resolves it from the user's
  // pmDefaultTab preference (falls back to 'overview').
  tab?: TabKey
  projectId?: string
  detailTab?: ProjectDetailTab
  taskId?: string
  eventId?: string
  eventMode?: 'create' | 'edit'
}

export type NavItem = {
  label: string
  description: string
  icon: IconType
  key: TabKey
  badge?: string
  badgeColor?: string
}

export type OverviewTask = {
  id: string
  title: string
  status: 'OPEN' | 'IN_PROGRESS' | 'READY_FOR_QC' | 'REOPENED' | 'CLOSED'
  kind: 'TASK' | 'BUG' | 'QC' | 'TICKET' | 'IDEA'
  priority: 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL'
  dueAt: string | null
  createdAt: string
  updatedAt: string
  closedAt: string | null
  projectId: string
  project: { id: string; name: string } | null
}

export type OverviewNotification = {
  id: string
  kind: NotificationKind
  taskId: string | null
  projectId: string | null
  title: string
  body: string | null
  readAt: string | null
  createdAt: string
  actor: { id: string; name: string; email: string } | null
}
